// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
//element组件引用
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
//百度地图
import BaiduMap from 'vue-baidu-map'
import stockInit from 'highcharts/modules/stock'
import Wordcloud from 'highcharts/modules/wordcloud';
import Highcharts from 'highcharts'
import HighStock from 'highcharts/highstock'
import HighchartsNoData from 'highcharts/modules/no-data-to-display'
import highcharts3d from 'highcharts/highcharts-3d'
import HighchartsVue from 'highcharts-vue'
import highchartsMore from 'highcharts/highcharts-more';
Vue.use(BaiduMap, {
  //百度地图密钥
  ak: '6PYkS1eDz5pMnyfO0jvBNE0F'
})
//导出EXCEL vue-json-excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
//导出EXCEL pikaz-excel-js
 import {ExcelExport} from 'pikaz-excel-js'
Vue.component('ExcelExport', ExcelExport)
highchartsMore(Highcharts);
HighchartsNoData(Highcharts);
highcharts3d(Highcharts);
Wordcloud(Highcharts)
stockInit(Highcharts)

Vue.use(HighchartsVue)
//状态管理，全局存储
import store from './store'
//axios
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
//自定义工具类
import Utils from './utils/utils.js';
Vue.prototype.utils=Utils;
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js